/*************
 * gtmSelectItem
 * Additional events for Algolia Click and Conversion tracking
 *
 */

custom.gtmSelectItem = (() => {
  const productLinkClass = 'product-card__image-wrapper'; // drawerID and class
  const productTitleLinkClass = 'js-product-name'; // drawerID and class

  function sendGTMSelectItemEvent($targetElement, includeSendViewItem = false) {
    if (!$targetElement) return;
    //Send GTM select_item and view_item events
    let itemIndex = $targetElement.data('item-index')
      ? $targetElement.data('item-index')
      : $targetElement.data('index')
        ? $targetElement.data('index')
        : 1;
    if (itemIndex) itemIndex = parseInt(itemIndex);
    const itemListName = $targetElement.data('item-list-name');
    const itemListId = $targetElement.data('item-list-id');
    const productId = $targetElement.data('product-id');
    const collectionName = $targetElement.data('collection-name');
    const collaborationName = $targetElement.data('collaboration-name');
    const itemColor = $targetElement.data('color');
    const title = $targetElement.data('label');
    if (productId) {
      let selectedItemFirstVariant = {
        item_id: productId ? productId.toString() : '',
        item_name: title ? title : '',
      };
      if (itemIndex) {
        selectedItemFirstVariant['index'] = itemIndex;
      }
      if (itemColor) {
        selectedItemFirstVariant['item_color'] = itemColor;
      }
      if (collectionName) {
        selectedItemFirstVariant['item_brand'] = collectionName;
      }
      if (collaborationName) {
        selectedItemFirstVariant['item_collaboration'] = collaborationName;
      }
      const data = {
        ecommerce: {
          currency: 'USD',
          item_list_id: itemListId ? itemListId : '',
          item_list_name: itemListName ? itemListName : '',
          items: [selectedItemFirstVariant],
        },
      };
      custom.gtmDatalayer.gtmPushNew(data, 'select_item');
      if (includeSendViewItem) {
        custom.gtmDatalayer.gtmPushNew(data, 'view_item');
      }
    }
  }

  function setupHandlers() {
    $('body').on(
      'click',
      `.${productLinkClass}, .${productTitleLinkClass}`,
      function (event) {
        if ($(event.target).hasClass('js-quick-view-button')) {
          //ignore quick view clicks, button has been placed inside link which is causing double counting
          return;
        }
        const $button = $(this);
        sendGTMSelectItemEvent($button, false);
      },
    );
  }

  function init() {
    setupHandlers();
  }
  return {
    sendGTMSelectItemEvent,
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/gtm-select-item.js